import React from "react";

import {useRequestQuery} from "../query";
import {DateFormatter} from "../../../services/date";
import {requestMapper} from "../../../mapper/requestMapper";

import LabelIcon from "@mui/icons-material/Label";
import FlagIcon from "@mui/icons-material/Flag";
import PeopleIcon from "@mui/icons-material/People";
import PetsIcon from "@mui/icons-material/Pets";
import NotesIcon from '@mui/icons-material/Notes';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import Card from "@mui/material/Card";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Skeleton from "@mui/material/Skeleton";


const OriginalRequest = ({quote}) => {
    const requestQuery = useRequestQuery(quote.requestId);

    const request = requestQuery.data !== undefined ? requestMapper(requestQuery.data) : undefined;

    const attributes = !request ? [] : [
        {
            value: `${DateFormatter.shortStringWithDayName(request.arrival)} - ${DateFormatter.shortStringWithDayName(request.departure)}`,
            defaultValue: "",
            label: "Arrivo e Partenza",
            icon: <CalendarMonthIcon/>,
        },
        {
            value: `Adulti ${request?.adults}, Bambini ${request?.children}`,
            defaultValue: "",
            label: "Adulti e Bambini",
            icon: <PeopleIcon/>,
        },
        {
            value: request?.petsNumber,
            defaultValue: 0,
            label: "Animali domestici",
            icon: <PetsIcon/>,
        },
        {
            value: request?.email,
            defaultValue: "",
            label: "Email",
            icon: <AlternateEmailIcon/>,
        },
        {
            value: `${request?.name} ${request?.surname}`,
            defaultValue: "",
            label: "Nome e Cognome",
            icon: <LabelIcon/>,
        },
        {
            value: request?.nationality?.label,
            defaultValue: "",
            label: "Nazionalità",
            icon: <FlagIcon/>,
        },
        {
            value: request?.content,
            defaultValue: "Nessuna nota",
            label: "Note",
            icon: <NotesIcon/>,
        },
    ]

    return <Card>
        {
            requestQuery.isLoading && <Stack spacing={1}>
                <Skeleton variant="rectangular" width={"100%"} height={60} />
                <Skeleton variant="rectangular" width={"100%"} height={60} />
                <Skeleton variant="rectangular" width={"100%"} height={60} />
                <Skeleton variant="rectangular" width={"100%"} height={60} />
                <Skeleton variant="rectangular" width={"100%"} height={60} />
                <Skeleton variant="rectangular" width={"100%"} height={60} />
                <Skeleton variant="rectangular" width={"100%"} height={60} />
            </Stack>
        }
        {
            request && <List disablePadding>
                {
                    attributes.map(({value, defaultValue, label, icon}, i) => (
                        <React.Fragment key={label}>
                            <ListItem>
                                <ListItemIcon>
                                    {icon}
                                </ListItemIcon>
                                <ListItemText primary={value || defaultValue}
                                              secondary={label}/>
                            </ListItem>
                            {i !== attributes.length - 1 && <Divider variant="inset"/>}
                        </React.Fragment>
                    ))
                }
            </List>
        }
    </Card>
}

export default OriginalRequest;